import React from 'react';
import PasswordInput from './PasswordInput';
import BirthdateInput from './BirthdateInput';
import PhoneNumberInput from './PhoneNumberInput';
import Checkbox from './Checkbox';
import Input from './Input';

var InputDispatcher = function InputDispatcher(props) {
  switch (props.type) {
    case 'hidden':
      return React.createElement('input', { type: props.type, name: props.name, value: props.value });
    case 'password':
      return React.createElement(PasswordInput, props);
    case 'birthdate':
      return React.createElement(BirthdateInput, props);
    case 'tel':
      return React.createElement(PhoneNumberInput, props);
    case 'checkbox':
      return React.createElement(Checkbox, props);
    default:
      return React.createElement(Input, props);
  }
};

export default InputDispatcher;